<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button (click)="openRenamePopup(null)" class="!w-[150px]"> Create </app-primary-button>
  </div>

  <div class="list-section">
    @if (dataSource?.length) {
      <div class="table-wrapper mb-[20px]">
        <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th *matHeaderCellDef class="text-type-8" mat-header-cell>Equipment</th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.name || row?.value }}</div>
            </td>
          </ng-container>
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row; let i = index" mat-cell>
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="deleteItem(row)">
                  <mat-icon svgIcon="trash"></mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <!-- Header & Row Definitions -->
          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        </table>
      </div>
    }

    <!-- No Data -->
    @if (!dataSource?.length) {
      <div class="no-data mt-[80px]">No data available.</div>
    }

    <!-- Paginator -->
    @if (totalRecords > 0) {
      <app-paginator
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="pagination?.pageSize"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator mt-[20px]"
        />
    }
  </div>
</div>
